module.exports = __webpack_public_path__ + "img/tetosArena.ae0610df.webp";